import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameShedLock extends cDisplay {

  private code: string[] = ['0','0','0']

  init(){
    super.init()
    console.log('GAME gameShedLock')
    var cS:cScene = this.scene as cScene;

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
      }
    })
  }

  buildScene(){    
    var cS:cScene = this.scene as cScene;
    
    super.buildScene();


    this.getByName('btn_1_up').events.addListener('click',()=>{ this.handleNumbers(0,1)  })
    this.getByName('btn_1_down').events.addListener('click',()=>{ this.handleNumbers(0,-1)  })
    this.getByName('btn_2_up').events.addListener('click',()=>{ this.handleNumbers(1,1)  })
    this.getByName('btn_2_down').events.addListener('click',()=>{ this.handleNumbers(1,-1)  })
    this.getByName('btn_3_up').events.addListener('click',()=>{ this.handleNumbers(2,1)  })
    this.getByName('btn_3_down').events.addListener('click',()=>{ this.handleNumbers(2,-1)  })

  }


  handleNumbers(col,sign){
    var v:number = Number(this.code[col])
    v += sign
    if (v > 9) v = 0
    if (v < 0) v = 9
    
    this.code[col] = String(v);

    (this.scene as cScene).setState('current_code',this.code.join(''))

    console.log(this.code)
    this.code.forEach( (v,i)=>{
      this.getByName('txt_'+(i+1)).textdata = String(v)
    })

  }

}
